import * as FavoritesUpdatedEvent from '@ori-events/favorites-updated';
import * as RequestFavoritesEvent from '@ori-events/request-favorites';
import { isAuthenticatedCustomer } from '@ori/auth';
import { isBeautyApp } from '@ori/beauty-app-info';
import { useCallback, useEffect, useState } from 'react';
export const useAreFavoritesEnabled = ({
  customerId
} = {}) => {
  const isAuthenticated = isAuthenticatedCustomer(customerId);
  const [areFavoritesEnabled, setAreFavoritesEnabled] = useState(false);
  const dispatchRequestFavoritesEvent = useCallback(() => {
    if (isAuthenticated && !isBeautyApp()) {
      window.dispatchEvent(new CustomEvent(RequestFavoritesEvent.Name));
    }
  }, [isAuthenticated]);
  useEffect(() => {
    const onLoad = () => setAreFavoritesEnabled(true);
    window.addEventListener(FavoritesUpdatedEvent.Name, onLoad);
    const timeout = setTimeout(dispatchRequestFavoritesEvent);
    return () => {
      window.removeEventListener(FavoritesUpdatedEvent.Name, onLoad);
      clearTimeout(timeout);
    };
  }, [dispatchRequestFavoritesEvent]);
  return areFavoritesEnabled;
};
//# sourceMappingURL=useAreFavoritesEnabled.js.map